export default __webpack_public_path__ + "PicsContact.21b9d36.png";